export default __webpack_public_path__ + "static/media/header_five.124cd768.jpg";